import React from 'react';

import { StatusChip } from '../../../../core-components/theme/components/StatusChip';
import type { StatusChipSize } from '../../../../core-components/theme/components/StatusChip';
import { SEVERITY_NAME } from '../../constants/labels';
import { SEVERITY_ICON, SEVERITY_TONE } from '../../constants/severityTone';
import type { Severity } from '../../types/domain.types';

export interface SeverityChipProps {
  severity: Severity;
  size?: StatusChipSize;
}

const iconOf = (severity: Severity): React.ReactElement => {
  const Icon = SEVERITY_ICON[severity];
  return <Icon aria-hidden />;
};

const ICON_ELEMENTS: Readonly<Record<Severity, React.ReactElement>> = {
  EMERGENCY: iconOf('EMERGENCY'),
  MAJOR: iconOf('MAJOR'),
  MINOR: iconOf('MINOR'),
  CAUTION: iconOf('CAUTION'),
};

const nameOf = (severity: Severity): React.ReactElement => <span lang="en">{SEVERITY_NAME[severity]}</span>;

const NAME_ELEMENTS: Readonly<Record<Severity, React.ReactElement>> = {
  EMERGENCY: nameOf('EMERGENCY'),
  MAJOR: nameOf('MAJOR'),
  MINOR: nameOf('MINOR'),
  CAUTION: nameOf('CAUTION'),
};

export const SeverityChip: React.FC<SeverityChipProps> = ({ severity, size = 'small' }) => {
  const tone = SEVERITY_TONE[severity];
  return (
    <StatusChip
      label={NAME_ELEMENTS[severity]}
      icon={ICON_ELEMENTS[severity]}
      size={size}
      fg={tone.fg}
      bg={tone.bg}
      border={tone.border}
    />
  );
};
